import { css } from 'goober';
import { isFunction } from 'mc-ui-utils';
import React, { memo, useCallback, useEffect, useRef, } from 'react';
import constants from '../../../constants';
import { addListeners, removeListeners } from '../../../utils/slider';
const HighlightNavigator = css `
  display: flex;
  justify-content: stretch;
  position: absolute;
  top: 115px;
  bottom: 140px;
  left: 0;
  right: 0;
`;
const CommonNav = (isExperimentEnabled) => css `
  position: absolute;
  top: 0;
  bottom: 0;
  width: ${isExperimentEnabled
    ? 25 /* EXPERIMENT_WIDTH */
    : 45 /* DEFAULT_WIDTH */}%;
`;
const PrevNav = css `
  left: 0;
`;
const NextNav = css `
  right: 0;
`;
const Navigator = ({ onNavigate, onHoldGlance, onUnHoldGlance, onToggleMode, isExperimentEnabled = false, }) => {
    const element = useRef();
    const isHoldingTimer = useRef(null);
    const onSwipeStart = useCallback(() => {
        if (!isHoldingTimer.current) {
            isHoldingTimer.current = window.setTimeout(() => {
                onHoldGlance();
            }, constants.HOLD_TIME);
        }
    }, [onHoldGlance]);
    const onSwipeEnd = useCallback(() => {
        if (isHoldingTimer.current) {
            clearTimeout(isHoldingTimer.current);
            isHoldingTimer.current = null;
        }
        onUnHoldGlance();
    }, [onUnHoldGlance]);
    const handleClick = (event) => {
        const target = event.target;
        const isDatasetEmpty = Object.keys(target.dataset).length === 0;
        if (isDatasetEmpty && isFunction(onToggleMode) && isExperimentEnabled) {
            onToggleMode();
        }
        else {
            onNavigate(event);
        }
    };
    useEffect(() => {
        const actualElement = element.current;
        addListeners(actualElement, { onSwipeStart, onSwipeEnd });
        return () => {
            removeListeners(actualElement, { onSwipeStart, onSwipeEnd });
        };
    }, [onSwipeEnd, onSwipeStart]);
    return (React.createElement("div", { className: HighlightNavigator, ref: element, onClick: handleClick },
        React.createElement("div", { className: `${CommonNav(isExperimentEnabled)} ${PrevNav}`, role: "button", "data-step": "-1" }),
        React.createElement("div", { className: `${CommonNav(isExperimentEnabled)} ${NextNav}`, role: "button", "data-step": "1" })));
};
const shouldNotRender = (prevProps, nextProps) => {
    return (prevProps.index === nextProps.index &&
        prevProps.isExperimentEnabled === nextProps.isExperimentEnabled);
};
export default memo(Navigator, shouldNotRender);
//# sourceMappingURL=index.js.map